module.exports = __webpack_public_path__ + "media/components/home/creator-community/img/holaillustrations-bkg-e24968c724f059dcbe81ff8715229c59.jpg";